import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { FolderDataSource } from 'src/app/acl-data/folder/folder.datasource';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { ObjectStoreService } from 'src/app/acl-data/object-store/object-store.service';

@Component({
    selector: 'app-browse-folders',
    templateUrl: './browse-folders.component.html',
    styleUrls: ['./browse-folders.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowseFoldersComponent implements OnChanges {
    @Input() folder: Folder;
    @Input() objectStore: string;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    loading$ = this.folderService.loading$;

    userRoles$ = this.objectStoreService.entities$.pipe(
        map(v => v.find(row => row.symbolicName === this.objectStore))
    );

    // folder$ = new BehaviorSubject<Folder>(this.folder);

    dataSource;

    displayedColumns$ = this.userRoles$.pipe(
        map(v =>
            v.superUser
                ? ['FolderName', 'FolderDescription', 'Settings']
                : ['FolderName', 'FolderDescription']
        )
    );

    constructor(
        private folderService: FolderService,
        private objectStoreService: ObjectStoreService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.dataSource = new FolderDataSource(
            this.folderService,
            this.folder,
            this.objectStore,
            this.paginator
        );

        // console.log(this.dataSource)
        // this.folder$.next(this.folder);
    }

    applySort(input: Sort) {
        this.dataSource.sortChanged(input);
    }

    paged(input: PageEvent) {
        this.dataSource.pageChange(input);
    }

    applyFilter(filterValue: string) {
        this.dataSource.filterChange(filterValue.trim().toLowerCase());

        if (this.paginator) {
            this.paginator.firstPage();
        }
    }
}
